// extracted by mini-css-extract-plugin
export default {"menuIcon":"UserDropdown_menuIcon__y21F3","userIcon":"UserDropdown_userIcon__eGoki","dropdownElement":"UserDropdown_dropdownElement__sb-mH"};